export default "__VITE_ASSET__Dt6D$skp__"